function withTrailingSlash(base) {
  const s = String(base || "").trim();
  if (!s) return "https://api.veeranshchemicals.com/";
  return s.endsWith("/") ? s : `${s}/`;
}

const isDev = process.env.NODE_ENV === "development";

/* Use 127.0.0.1 in dev: on some Windows setups `localhost` resolves to IPv6 first and can hang if the API only listens on IPv4. */
const defaultApi =
  isDev && !process.env.REACT_APP_API_BASE_URL
    ? "http://127.0.0.1:5031/"
    : "https://api.veeranshchemicals.com/";

/** Override with `.env.local`: REACT_APP_API_BASE_URL=... (always wins). */
export const API_BASE_URL = withTrailingSlash(
  process.env.REACT_APP_API_BASE_URL || defaultApi,
);

const defaultMedia =
  isDev && !process.env.REACT_APP_MEDIA_URL
    ? `${API_BASE_URL.replace(/\/+$/, "")}/uploads`
    : "https://api.veeranshchemicals.com/uploads";

/** Override with `.env.local`: REACT_APP_MEDIA_URL=... */
export const MEDIA_URL =
  process.env.REACT_APP_MEDIA_URL || defaultMedia;

export const ApiEndPoints = {
  AUTH: {
    login: `${API_BASE_URL}api/v1/admin/auth/login`,
    me: `${API_BASE_URL}api/v1/admin/auth/me`,
    requestOtp: `${API_BASE_URL}api/v1/admin/auth/forgot/password`,
    verifyotp: `${API_BASE_URL}api/v1/admin/auth/verify/otp`,
    reset: `${API_BASE_URL}api/v1/admin/auth/reset/password`,
    resendOtp: (type) => `${API_BASE_URL}api/v1/admin/auth/resend/otp/${type}`,
    changePassword: `${API_BASE_URL}api/v1/admin/auth/change/password`,
  },
  DASHBOARD: {
    count: `${API_BASE_URL}api/v1/admin/dashboard/stats`,
  },
  CONTACT_US: {
    list: `${API_BASE_URL}api/v1/admin/get-in-touch`,
    exportCsv: `${API_BASE_URL}api/v1/admin/get-in-touch/export/csv`,
    getById: (id) => `${API_BASE_URL}api/v1/admin/get-in-touch/${id}`,
    respond: (id) => `${API_BASE_URL}api/v1/admin/get-in-touch/${id}`,
    delete: (id) => `${API_BASE_URL}api/v1/admin/get-in-touch/${id}`,
    restore: (id) => `${API_BASE_URL}api/v1/admin/get-in-touch/${id}/restore`,
    markSeen: (id) => `${API_BASE_URL}api/v1/admin/get-in-touch/${id}/mark-seen`,
  },
  LEGAL_CONTENT: {
    list: (type) => `${API_BASE_URL}api/v1/admin/legal-content/${type}`,
    edit: (type) => `${API_BASE_URL}api/v1/admin/legal-content/${type}`,
  },
  FAQ: {
    list: `${API_BASE_URL}api/v1/admin/faq`,
    create: `${API_BASE_URL}api/v1/admin/faq`,
    edit: (id) => `${API_BASE_URL}api/v1/admin/faq/update/${id}`,
    delete: (id) => `${API_BASE_URL}api/v1/admin/faq/${id}`,
  },
  CAREER: {
    list: `${API_BASE_URL}api/v1/admin/career`,
    create: `${API_BASE_URL}api/v1/admin/career`,
    edit: (id) => `${API_BASE_URL}api/v1/admin/career/update/${id}`,
    delete: (id) => `${API_BASE_URL}api/v1/admin/career/${id}`,
  },
  CAREER_APPLICATIONS: {
    list: `${API_BASE_URL}api/v1/admin/career-applications`,
    get: (id) => `${API_BASE_URL}api/v1/admin/career-applications/${id}`,
    update: (id) => `${API_BASE_URL}api/v1/admin/career-applications/${id}`,
    delete: (id) => `${API_BASE_URL}api/v1/admin/career-applications/${id}`,
    restore: (id) => `${API_BASE_URL}api/v1/admin/career-applications/${id}/restore`,
    resume: (id) => `${API_BASE_URL}api/v1/admin/career-applications/${id}/resume`,
    statusHistory: (id) =>
      `${API_BASE_URL}api/v1/admin/career-applications/${id}/status-history`,
    exportCsv: `${API_BASE_URL}api/v1/admin/career-applications/export/csv`,
  },

  BLOG: {
    list: `${API_BASE_URL}api/v1/admin/blog`,
    create: `${API_BASE_URL}api/v1/admin/blog`,
    imageUpload: `${API_BASE_URL}api/v1/admin/blog-image`,
    edit: (id) => `${API_BASE_URL}api/v1/admin/blog/update/${id}`,
    delete: (id) => `${API_BASE_URL}api/v1/admin/blog/${id}`,
    blogById: (id) => `${API_BASE_URL}api/v1/admin/blog/${id}`,
    updateCommentStatus: (id) =>
      `${API_BASE_URL}api/v1/admin/blog/blog-comment/${id}`,
  },
  BLOG_AUTHORS: {
    list: `${API_BASE_URL}api/v1/admin/blog-author`,
    create: `${API_BASE_URL}api/v1/admin/blog-author`,
    get: (id) => `${API_BASE_URL}api/v1/admin/blog-author/${id}`,
    edit: (id) => `${API_BASE_URL}api/v1/admin/blog-author/${id}`,
    delete: (id) => `${API_BASE_URL}api/v1/admin/blog-author/${id}`,
  },
  MEDIA: {
    list: `${API_BASE_URL}api/v1/admin/media-exhibition-highlight`,
    create: `${API_BASE_URL}api/v1/admin/media-exhibition-highlight`,
    edit: (id) =>
      `${API_BASE_URL}api/v1/admin/media-exhibition-highlight/update/${id}`,
    delete: (id) =>
      `${API_BASE_URL}api/v1/admin/media-exhibition-highlight/${id}`,
  },
  MEDIA_EXHIBITION_BANNER_IMAGES: {
    list: `${API_BASE_URL}api/v1/admin/media-exhibition-highlight/banner`,
    create: `${API_BASE_URL}api/v1/admin/media-exhibition-highlight/banner`,
    edit: (id) =>
      `${API_BASE_URL}api/v1/admin/media-exhibition-highlight/banner/update/${id}`,
    delete: (id) =>
      `${API_BASE_URL}api/v1/admin/media-exhibition-highlight/banner/${id}`,
  },
  BANNER_IMAGES: {
    list: `${API_BASE_URL}api/v1/admin/banner`,
    create: `${API_BASE_URL}api/v1/admin/banner`,
    edit: (id) => `${API_BASE_URL}api/v1/admin/banner/update/${id}`,
    delete: (id) => `${API_BASE_URL}api/v1/admin/banner/${id}`,
  },
  PRODUCTS: {
    list: `${API_BASE_URL}api/v1/admin/products`,
    summary: `${API_BASE_URL}api/v1/admin/products/summary`,
    simpleList: `${API_BASE_URL}api/v1/admin/products/simple`,
    simpleSearch: (search = "") =>
      `${API_BASE_URL}api/v1/admin/products/simple/${encodeURIComponent(search)}`,
    getById: (id) => `${API_BASE_URL}api/v1/admin/products/${id}`,
    create: `${API_BASE_URL}api/v1/admin/products`,
    edit: (id) => `${API_BASE_URL}api/v1/admin/products/${id}`,
    delete: (id) => `${API_BASE_URL}api/v1/admin/products/${id}`,
  },

  PRODUCT_CATEGORY: {
    list: `${API_BASE_URL}api/v1/admin/product-category`,
    create: `${API_BASE_URL}api/v1/admin/product-category`,
    edit: (id) => `${API_BASE_URL}api/v1/admin/product-category/${id}`,
    delete: (id) => `${API_BASE_URL}api/v1/admin/product-category/${id}`,
    changeSRno: (id, action) =>
      `${API_BASE_URL}api/v1/admin/product-category/${id}/order/${action}`,
  },
  PRODUCT_SPECIFICATION: {
    create: (id) => `${API_BASE_URL}api/v1/admin/products/${id}/specification`,
    bulkCreate: (id) =>
      `${API_BASE_URL}api/v1/admin/products/${id}/specifications`,
    edit: (productId, specId) =>
      `${API_BASE_URL}api/v1/admin/products/${productId}/specifications/${specId}`,
    delete: (productId, specId) =>
      `${API_BASE_URL}api/v1/admin/products/${productId}/specifications/${specId}`,
  },
  CERTIFICATIONS: {
    create: (id) => `${API_BASE_URL}api/v1/admin/products/${id}/certifications`,
    edit: (productId, certId) =>
      `${API_BASE_URL}api/v1/admin/products/${productId}/certifications/${certId}`,
    delete: (productId, certId) =>
      `${API_BASE_URL}api/v1/admin/products/${productId}/certifications/${certId}`,
  },
  PRODUCT_IMAGES: {
    add: (id) => `${API_BASE_URL}api/v1/admin/products/${id}/images`,
    edit: (productId, imageId) =>
      `${API_BASE_URL}api/v1/admin/products/${productId}/images/${imageId}`,
    delete: (productId, imageId) =>
      `${API_BASE_URL}api/v1/admin/products/${productId}/images/${imageId}`,
  },
  PRODUCT_VIDEOS: {
    add: (id) => `${API_BASE_URL}api/v1/admin/products/${id}/videos`,
    edit: (productId, videoId) =>
      `${API_BASE_URL}api/v1/admin/products/${productId}/videos/${videoId}`,
    delete: (productId, videoId) =>
      `${API_BASE_URL}api/v1/admin/products/${productId}/videos/${videoId}`,
  },
  PRODUCT_APPLICATIONS: {
    add: (id) => `${API_BASE_URL}api/v1/admin/products/${id}/applications`,
    edit: (productId, appId) =>
      `${API_BASE_URL}api/v1/admin/products/${productId}/applications/${appId}`,
    delete: (productId, appId) =>
      `${API_BASE_URL}api/v1/admin/products/${productId}/applications/${appId}`,
  },
  WHY_CHOOSE_US: {
    create: (id) => `${API_BASE_URL}api/v1/admin/products/${id}/why-choose`,
    edit: (productId, id) =>
      `${API_BASE_URL}api/v1/admin/products/${productId}/why-choose/${id}`,
    delete: (productId, id) =>
      `${API_BASE_URL}api/v1/admin/products/${productId}/why-choose/${id}`,
  },
  PRODUCT_FAQ: {
    create: (id) => `${API_BASE_URL}api/v1/admin/products/${id}/faqs`,
    edit: (productId, faqId) =>
      `${API_BASE_URL}api/v1/admin/products/${productId}/faqs/${faqId}`,
    delete: (productId, faqId) =>
      `${API_BASE_URL}api/v1/admin/products/${productId}/faqs/${faqId}`,
  },
  OUR_TEAM: {
    list: `${API_BASE_URL}api/v1/admin/our-team`,
    create: `${API_BASE_URL}api/v1/admin/our-team`,
    edit: (id) => `${API_BASE_URL}api/v1/admin/our-team/${id}`,
    delete: (id) => `${API_BASE_URL}api/v1/admin/our-team/${id}`,
  },
  ALL_INDUSTRIES: {
    list: `${API_BASE_URL}api/v1/admin/industries`,
    create: `${API_BASE_URL}api/v1/admin/industries`,
    industryById: (id) => `${API_BASE_URL}api/v1/admin/industries/${id}`,
    edit: (id) => `${API_BASE_URL}api/v1/admin/industries/${id}`,
    delete: (id) => `${API_BASE_URL}api/v1/admin/industries/${id}`,
  },
  INDUSTRY_IMAGES: {
    list: (id) => `${API_BASE_URL}api/v1/admin/industry-images/industry/${id}`,
    add: (id) => `${API_BASE_URL}api/v1/admin/industry-images/${id}`,
    edit: (industryId, id) =>
      `${API_BASE_URL}api/v1/admin/industry-images/${industryId}/image/${id}`,
    delete: (id) => `${API_BASE_URL}api/v1/admin/industry-images/${id}`,
  },
  INDUSTRY_FAQS: {
    list: (id) => `${API_BASE_URL}api/v1/admin/industry-faqs/industry/${id}`,
    add: (id) => `${API_BASE_URL}api/v1/admin/industry-faqs/${id}`,
    edit: (id, faqId) =>
      `${API_BASE_URL}api/v1/admin/industry-faqs/${id}/faq/${faqId}`,
    delete: (id) => `${API_BASE_URL}api/v1/admin/industry-faqs/${id}`,
  },
  APPLICATIONS: {
    list: `${API_BASE_URL}api/v1/admin/applications`,
    add: `${API_BASE_URL}api/v1/admin/applications`,
    edit: (id) => `${API_BASE_URL}api/v1/admin/applications/${id}`,
    delete: (id) => `${API_BASE_URL}api/v1/admin/applications/${id}`,
  },
  CREATE_RANGE: {
    list: (industryId) =>
      `${API_BASE_URL}api/v1/admin/range-of-solutions/industry/${industryId}`,
    add: (industryId) =>
      `${API_BASE_URL}api/v1/admin/range-of-solutions/${industryId}`,
    edit: (industryId, rangeId) =>
      `${API_BASE_URL}api/v1/admin/range-of-solutions/${industryId}/range/${rangeId}`,
    delete: (rangeId) =>
      `${API_BASE_URL}api/v1/admin/range-of-solutions/${rangeId}`,
  },
  RANGE_PRODUCTS: {
    list: (rangeId) =>
      `${API_BASE_URL}api/v1/admin/range-of-solution-products/range/${rangeId}`,
    add: (rangeId) =>
      `${API_BASE_URL}api/v1/admin/range-of-solution-products/range/${rangeId}`,
    edit: (rangeId, productId) =>
      `${API_BASE_URL}api/v1/admin/range-of-solution-products/range/${rangeId}/product/${productId}`,
    delete: (productId) =>
      `${API_BASE_URL}api/v1/admin/range-of-solution-products/${productId}`,
  },
  SEO: {
    get: `${API_BASE_URL}api/v1/admin/seo`,
    add: `${API_BASE_URL}api/v1/admin/seo`,
    edit: (id) => `${API_BASE_URL}api/v1/admin/seo/update/${id}`,
    delete: (id) => `${API_BASE_URL}api/v1/admin/seo/${id}`,
  },
  TALK_TO_EXPERT: {
    get: `${API_BASE_URL}api/v1/admin/misc/talk-to-expert`,
    exportCsv: `${API_BASE_URL}api/v1/admin/misc/talk-to-expert/export/csv`,
    delete: (id) =>
      `${API_BASE_URL}api/v1/admin/misc/talk-to-expert/${id}`,
    restore: (id) =>
      `${API_BASE_URL}api/v1/admin/misc/talk-to-expert/${id}/restore`,
    markSeen: (id) =>
      `${API_BASE_URL}api/v1/admin/misc/talk-to-expert/${id}/mark-seen`,
  },
  TALK_TO_EXP0RT: {
    get: `${API_BASE_URL}api/v1/admin/misc/talk-to-export`,
    exportCsv: `${API_BASE_URL}api/v1/admin/misc/talk-to-export/export/csv`,
    delete: (id) =>
      `${API_BASE_URL}api/v1/admin/misc/talk-to-export/${id}`,
    restore: (id) =>
      `${API_BASE_URL}api/v1/admin/misc/talk-to-export/${id}/restore`,
    markSeen: (id) =>
      `${API_BASE_URL}api/v1/admin/misc/talk-to-export/${id}/mark-seen`,
  },
  QUOTE_REQUEST: {
    get: `${API_BASE_URL}api/v1/admin/misc/quote-request`,
    exportCsv: `${API_BASE_URL}api/v1/admin/misc/quote-request/export/csv`,
    delete: (id) =>
      `${API_BASE_URL}api/v1/admin/misc/quote-request/${id}`,
    restore: (id) =>
      `${API_BASE_URL}api/v1/admin/misc/quote-request/${id}/restore`,
    markSeen: (id) =>
      `${API_BASE_URL}api/v1/admin/misc/quote-request/${id}/mark-seen`,
  },
  SAMPLE_REQUEST: {
    get: `${API_BASE_URL}api/v1/admin/misc/sample-request`,
    exportCsv: `${API_BASE_URL}api/v1/admin/misc/sample-request/export/csv`,
    delete: (id) =>
      `${API_BASE_URL}api/v1/admin/misc/sample-request/${id}`,
    restore: (id) =>
      `${API_BASE_URL}api/v1/admin/misc/sample-request/${id}/restore`,
    markSeen: (id) =>
      `${API_BASE_URL}api/v1/admin/misc/sample-request/${id}/mark-seen`,
  },
  NEWSLETTER_SUBSCRIBERS: {
    get: `${API_BASE_URL}api/v1/admin/misc/newsletter-subscribers`,
    exportCsv: `${API_BASE_URL}api/v1/admin/misc/newsletter-subscribers-export`,
    delete: (id) =>
      `${API_BASE_URL}api/v1/admin/misc/newsletter-subscribers/${id}`,
    restore: (id) =>
      `${API_BASE_URL}api/v1/admin/misc/newsletter-subscribers/${id}/restore`,
  },
  OUR_POPULAR_PRODUCTS: {
    get: `${API_BASE_URL}api/v1/admin/popular-product`,
    add: `${API_BASE_URL}api/v1/admin/popular-product`,
  },
  DYES_PIGMENTS: {
    get: `${API_BASE_URL}api/v1/admin/industry-product-dyes`,
    add: `${API_BASE_URL}api/v1/admin/industry-product-dyes`,
    edit: (id) => `${API_BASE_URL}api/v1/admin/industry-product-dyes/${id}`,
    delete: (id) => `${API_BASE_URL}api/v1/admin/industry-product-dyes/${id}`,
  },
  MARKETPLACE: {
    locations: `${API_BASE_URL}api/v1/admin/marketplace/locations`,
    locationById: (id) => `${API_BASE_URL}api/v1/admin/marketplace/locations/${id}`,
    locationDeactivate: (id) => `${API_BASE_URL}api/v1/admin/marketplace/locations/${id}`,
    locationProducts: (id) =>
      `${API_BASE_URL}api/v1/admin/marketplace/locations/${id}/products`,
    reapplyDefault: (id) =>
      `${API_BASE_URL}api/v1/admin/marketplace/locations/${id}/reapply-default`,
    defaultSelection: `${API_BASE_URL}api/v1/admin/marketplace/default-selection`,
  },
};
